export default __webpack_public_path__ + "static/androidapp-d2f97d0432b0668c6503505ca58225a5.webp";